export function getFailAppLaunchUrl() {
  return 'diva://gov-trust/fail';
}
